import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { accountLedgers } from "../../../../../../../../redux/account-ledgers/action";
import { selectAccountLedgersListItems } from "../../../../../../../../redux/account-ledgers/selector";

const ManagementAccountLedgers = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const parmas: any = useParams()
    const [pageData, setPageData] = useState(1)
    const accountledgersItems = useSelector(selectAccountLedgersListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'LedgerName', headerName: 'Ledger Name' },
            { field: 'AccountCategoryName', headerName: 'Account Category Name' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
        ]);
    }

    const fetchAccountLedgersList = () => {
        dispatch(accountLedgers.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/ledgers/list`,
            entity: 'accountLedgers',
            jsonData: {
                Filters: [
                    {
                        FieldName: 'OwnerType',
                        FilterOperatorId: 1,
                        FieldValue: 'Account',
                        FieldType: 'text'
                    },
                    {
                        FieldName: 'OwnerId',
                        FilterOperatorId: 1,
                        FieldValue: parmas?.id,
                        FieldType: 'number'
                    }
                ],
                isFilterConditionOr: false
            }
        }));
    }

    useEffect(() => {
        createColumnDefs()
        fetchAccountLedgersList()
    }, [pageData])

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
    }

    return (
        <>
            {accountledgersItems?.isLoading ?
                <PageLoader /> :
                <Table columnData={columnDefs} rowData={accountledgersItems?.result?.items} setPageData={setPageData}
                    paginationData={accountledgersItems?.result?.pagination} onEdit={handleEdit} headingName="Account Ledgers" />
            }
        </>
    );
};

export default ManagementAccountLedgers;
